var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sortedBlockArray),function(item,itemIndex){return _c(item.case === 'cards' ? _vm.SectionCardRow : 'div',{key:("item-" + itemIndex),tag:"component",class:{
            'btn-wrapper': item.case === 'buttons',
            'mblock-end-6': _vm.hasItemMarginEnd(item),
        }},_vm._l((item.blocks),function(block,index){return _c('TBlock',{key:("item-" + itemIndex + "-block-index-" + index),class:{
                'mblock-6': _vm.hasBlockMargin(block),
            },attrs:{"block":block}})}),1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }